<template>
  <div class="table">
    <div class="params-form">
      <a-form-model ref="searchForm" layout="inline" :model="formState">
        <!--④查询条件字段名+组件+提示文字+请输入提示文字-->
        <a-form-model-item label="受检单位名称" prop="name">
          <a-row>
            <a-col span="18">
          <a-input v-model="formState.name"></a-input>
            </a-col>
            <a-col span="1">
            </a-col>
            <a-col span="5">
              <a-button type="primary" @click="onChoiceNeedCheckModalOpen">选择</a-button>
            </a-col>
          </a-row>
        </a-form-model-item>
        <a-form-model-item label="监测环节" prop="link">
          <div style="display: inline-block;width: 100px">
          <a-ext-task-link-select :project-id="projectId" v-model="formState.link"></a-ext-task-link-select>
          </div>
        </a-form-model-item>
        <a-form-model-item label="抽样品种" prop="pickType">
          <div style="display: inline-block;width: 100px">
          <a-ext-task-produce-select :project-id="projectId" v-model="formState.pickType"></a-ext-task-produce-select>
          </div>
        </a-form-model-item>
        <a-form-model-item label="抽样数分配" prop="pickCount">
          <a-input-number id="inputNumber" v-model="formState.pickCount" :min="1" :max="10000" />
        </a-form-model-item>
        <a-form-model-item>
          <a-space>
            <a-button type="primary" icon="plus" @click="onAddTarget">添加至任务列表</a-button>
          </a-space>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div class="table-content">
      <div>
        <div class="title" style="width: 650px;display: inline-block">
          监测项目管理
          <div v-if="selectedRowCount" style="width: 150px;display: inline-block;line-height: 20px;color: darkorange">
            共选择{{selectedRowCount}}条
          </div>
          <div style="width: 350px;display: inline-block;line-height: 20px;color: darkgray;font-weight: 600;font-size: 14px">
            需分配任务数{{total}}已分配任务数{{done}}
          </div>
        </div>

      </div>


      <a-config-provider :locale="locale">
        <a-table
                :data-source="dataSource"
                :columns="columns"
                :pagination="pagination"
                :loading="loading"
                row-key="id"
                @change="onPageChange"
                :scroll="{ y: 500 }"
        >
          <template slot="caozuo" slot-scope="text, record">
            <span style="color: orange;cursor: pointer" @click="onDelete(record)">删除</span>
          </template>
        </a-table>
      </a-config-provider>
    </div>
    <choice-need-check-modal v-if="choiceNeedCheckModalVisable" :visible.sync="choiceNeedCheckModalVisable"
                             :param="choiceNeedCheckModalParam"
                             @dialogBack="onChoiceNeedCheckModalClose"></choice-need-check-modal>
  </div>
</template>

<script>
//分页查询接口  ①分页查询SQL
import {getMonitPickPage as getPage,addorUpdateMonitPick} from '../../../api/api'
import {delMonitPickSelected as delPage} from '../../../api/api'
//各个字段  ③查询条件选择组件
import AExtTaskProduceSelect from '../../../components/AntDesignExt/All/AExtTaskProduceSelect'
import AExtTaskLinkSelect from '../../../components/AntDesignExt/All/AExtTaskLinkSelect'
import ChoiceNeedCheckModal from './ChoiceNeedCheckModal'

import _ from 'lodash'
import ExportJsonExcel from "js-export-excel"
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default {
    //各个字段  ⑤查询条件选择组件
    components: {
        AExtTaskProduceSelect,AExtTaskLinkSelect, ChoiceNeedCheckModal,
    },
    props: {
        projectId: {
            type: String,
            default: ''
        },
        taskId:{
            type: String,
            default: ''
        },
        total:{
            type:Number,
            default:0
        }
    },
    data() {
        return {
            locale: zhCN,
            done:'0',
            formState: {
                //②查询条件字段名
                name: ''
            },
            params: {},
            // 表头
            columns: [
                {
                    title: "受检单位名称",
                    dataIndex: "name",
                    width: "180px",
                    ellipsis: true,
                },
                {
                    title: "抽样品种",
                    dataIndex: "pickType",
                    width: "80px",
                    ellipsis: true,
                },
                {
                    title: "抽样数量",
                    dataIndex: "pickCount",
                    width: "90px",
                    ellipsis: true,
                },
                {
                    title: "法人或负责人",
                    dataIndex: "bossName",
                    width: "120px",
                    ellipsis: true,
                },
                {
                    title: "联系方式",
                    dataIndex: "tel",
                    width: "120px",
                    ellipsis: true,
                },
                {
                    title: "所属市",
                    dataIndex: "citiy",
                    width: "80px",
                    ellipsis: true,
                },
                {
                    title: "所属区县",
                    dataIndex: "district",
                    width: "90px",
                    ellipsis: true,
                },
                {
                    title: "详细地址",
                    dataIndex: "address",
                    width: "120px",
                    ellipsis: true,
                },
                {
                    title: "所属监测环节",
                    dataIndex: "link",
                    width: "120px",
                    ellipsis: true,
                },
                {
                    title: "操作",
                    dataIndex: "id",
                    width: "120px",
                    scopedSlots: {customRender: "caozuo"},
                },
            ],
            // 表格数据
            dataSource: [],
            // 选中的行
            selectedRowKeys: [],
            selectedRows: [],
            loading: false,
            // 分页器
            pagination: {
                total: 0,
                current: 1,
                pageSize: 5,
                pageSizeOptions: ["5", "15", "35", "45"],
                showSizeChanger: true,
                size: "small",
                showTotal: total => `共${total}条记录 `
            },
            choiceNeedCheckModalVisable: false,
            choiceNeedCheckModalBackChange: null,
            choiceNeedCheckModalParam: null
        };
    },
    mounted() {
        this.onSearchPage();
    },
    computed: {
        selectedRowCount() {
            return this.selectedRowKeys.length;
        }
    },
    methods: {
        // 查询
        onSearchPage() {
            this.selectedRowKeys = [];
            this.selectedRows = [];
            this.pagination.current = 1;
            this.params = {
                pageSize: this.pagination.pageSize,
                current: this.pagination.current
            };
            this.getData(this.params);
        },
        //重置
        onResetSearch() {
            this.$refs.searchForm.resetFields();this.onSearchPage();
        },
        // 翻页
        onPageChange(pagination, filters, sorter) {
            this.pagination = pagination;
            this.params.pageSize = pagination.pageSize;
            this.params.current = pagination.current;
            this.getData(this.params);
        },
        // 请求接口查询数据
        getData(params) {
            this.loading = true;
            this.params.taskId=this.taskId;
            getPage(params).then(result => {
                this.done=result.data.oper;
                this.pagination.total = result.data.data.total;
                this.pagination.current = result.data.data.current;
                this.pagination.pageSize = result.data.data.size;
                this.dataSource = result.data.data.records.map((item, index) => {
                    item.index = index + 1
                    return item
                });
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            })
        },
        // 复选框变化
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
            let removedItems = [];
            let addItems = [];
            this.selectedRows.forEach(oldSelectedItem => {
                if (!selectedRowKeys.includes(oldSelectedItem.id)) {
                    removedItems.push(oldSelectedItem);
                }
            });
            this.selectedRowKeys.forEach(newKey => {
                let find = false;
                this.selectedRows.forEach(oldSelectedItem => {
                    if (oldSelectedItem.id === newKey) {
                        find = true;
                    }
                });
                if (!find) {
                    this.dataSource.forEach(thisPageItem => {
                        if (thisPageItem.id === newKey) {
                            addItems.push(thisPageItem);
                        }
                    })
                }
            });
            removedItems.forEach(row => {
                this.selectedRows.remove(row)
            });
            this.selectedRows = this.selectedRows.concat(addItems)
        },
        onDelete(record) {
            let param=this.params;
            let getData=this.getData;
            this.$confirm({
                title: '是否删除数据?',
                content: '确认后数据将永久删除，是否确认？',
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    delPage(record.id).then(() => {
                        getData(param);
                    }).catch(err => {
                      // alert(err)
                    });
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        },
        onChoiceNeedCheckModalOpen(record) {
            this.choiceNeedCheckModalParam = {id: record.id};
            this.choiceNeedCheckModalVisable = true;
            //TODO: 无
        },
        onChoiceNeedCheckModalClose(e) {
            //TODO: 无
            this.formState.name=e.name;
            this.formState.link=e.link;
        },

        onChoice() {
            //TODO:无
        },
        // 批量删除
        onBatchDelete() {
            if (this.selectedRowKeys.length === 0) {
                this.$message.error('请选择要删除的数据');
                return
            }
            let keys = this.selectedRowKeys;
            let funcOK = () => {
                delPage(_.join(keys, ',')).then(() => {
                    this.selectedRowKeys = [];
                    this.selectedRows = [];
                    this.getData(this.params);
                }).catch(err => {
                    this.$message.error(err.message);
                });
            }
            this.$confirm({
                title: '是否删除数据?',
                content: '确认后数据将永久删除，是否确认？',
                okText: '确认',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    funcOK();
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        },
        // 导出excel
        onExportExcel() {
            if (this.selectedRowKeys.length == 0) {
                this.$message.error('请选择要导出的数据');
                return
            }
            let sheetColHeader=[];
            let sheetColFilter=[];
            this.columns.forEach(col=>{
                if(col.title !== '操作') {
                    sheetColFilter.push(col.dataIndex)
                    sheetColHeader.push(col.title)
                }
            });
            let exportRows=[];
            let i=0;
            this.selectedRows.forEach(item=>{
                i++;
                let newItem=_.cloneDeep(item);
                newItem.index=i.toString();
                exportRows.push(newItem)
            });
            let option = {};
            option.fileName = "监测项目管理";
            option.datas = [
                {
                    sheetData: exportRows,
                    sheetName: "监测项目管理",
                    sheetFilter: sheetColFilter,
                    sheetHeader: sheetColHeader,
                    columnWidths: [],
                },
            ];

            var toExcel = new ExportJsonExcel(option); //new
            toExcel.saveExcel();
        },
        onAddTarget()
        {
            this.formState.taskId=this.taskId;
            addorUpdateMonitPick(this.formState).then(result => {
                if(result.data.data===true)
                {
                    this.getData(this.params)
                }
                else {
                    alert('失败')
                }
            }).catch(() => {

            })
        }
    },
};
</script>
<style lang="scss" scoped>
  .table {
    .params-form {
      padding-top: 16px;
      padding-left: 20px;
      margin: 16px;
      display: flex;
      -webkit-box-align: center;
      align-items: center;
      -webkit-box-pack: justify;
      justify-content: space-between;
      border-radius: 8px;
      background-color: rgb(255, 255, 255);
      box-shadow: #1b2f7017 0px 2px 4px 2px;
    }
    .table-content {
      margin: 16px;
      padding: 20px 24px;
      box-shadow: #1b2f7017 0px 2px 4px 2px;
      background-color: rgb(255, 255, 255);
      border-radius: 8px;
      overflow-y: hidden;
      .title {
        padding-left: 12px;
        font-size: 16px;
        font-weight: 500;
        line-height: 1;
        color: rgba(0, 0, 0, 0.85);
        position: relative;
        margin-bottom: 16px;
        display: flex;
        -webkit-box-pack: justify;
        justify-content: space-between;
        -webkit-box-align: center;
        align-items: center;
      }
      .title::before {
        content: '';
        position: absolute;
        height: 16px;
        top: calc(50% - 8px);
        left: 0px;
        width: 3px;
        background-color: rgb(36, 113, 210);
      }

      .btn {
        padding-bottom: 15px;
        display: flex;
        justify-content: end;
      }

      /deep/ .ant-table-wrapper {
        .ant-table {
          border-top: 1px solid rgba(15, 41, 61, 0.45);
          border-bottom: 1px solid rgba(15, 41, 61, 0.45);
          border-image: initial;
          border-left: none;
          border-right: none;
        }
        .ant-table-thead {
          background: #fafafa;
        }
        .ant-table-thead > tr > th {
          font-weight: 500;
          line-height: 1;
          color: rgba(21, 40, 77, 0.65);
          background-color: rgb(245, 250, 255);
        }
      }
    }
  }
</style>
